import { useIsFetching } from "@tanstack/react-query"

import { VERTICAL_SIGNS_ROOT_QUERY_KEY } from "./queries/verticalSigning/queryKeys"

export function useIsFetchingVerticalSigning() {
    const isFetchingVerticalSigningLayers = useIsFetching({ queryKey: [VERTICAL_SIGNS_ROOT_QUERY_KEY, "layer"] })

    return isFetchingVerticalSigningLayers > 0
}